export function getStatusClass(status) {
  switch (status) {
    case "New":
      return "statusNew";
    case "Accepted":
      return "statusAccepted";
    case "Picked":
      return "statusPicked";
    case "Cancelled":
      return "statusCancelled";
    case "Delivered":
      return "statusDelivered";
    case "Postponed":
      return "statusPostponed";
    default:
      return "Waiting";
  }
}
